<div class="flex flex-col relative gap-medpace">
    @if (hasFile()) {
        <mds-icon-button
            [id]="'delete-btn'"
            [icon]="'delete'"
            (clickEvent)="removeFile()"
            [tooltip]="'Delete'"
            class="remove-button danger outline"
        ></mds-icon-button>
    }
    <div class="dropzone p-medpace" (click)="upload()" dragAndDropField (fileDropped)="onFileSelected($event)">
        <div class="flex flex-col gap-medpace">
            <div [ngClass]="{ hidden: hasFile() }">
                <p class="mb-medpace">
                    Please upload files only in
                    {{ acceptableTypesDisplay() }}
                    formats.
                </p>
                <i class="fas fa-cloud-upload-alt text-8xl"></i>
            </div>

            @if (hasFile()) {
                @if (!fileId()) {
                    <div>
                        {{ fileName() }}
                    </div>
                } @else {
                    <a (click)="downloadFile($event)">
                        {{ fileName() }}
                    </a>
                }
            }
            @if (isFileTypeImage()) {
                <img
                    class="mx-auto max-h-96 max-w-96 object-contain z-[4] bg-white"
                    [src]="url()"
                    alt="{{ file().name }}"
                />
            }
        </div>
    </div>

    @for (alert of fileAlerts(); track alert) {
        <medpace-alert
            [attr.data-cy]="alert.dataCy"
            [appearance]="alert.type"
            [content]="alert.content"
            [dismissable]="alert.type === 'danger' ? false : true"
            (closeMessageEvent)="removeAlert(alert)"
        />
    }

    @if ((attachmentSizeService.allUploadedFilesSizeExceeded$ | async) && displayMultipleFilesSizeExceeded() === true) {
        <medpace-alert
            data-cy="attachement-exceeded-limit"
            [appearance]="'danger'"
            [content]="`Submission has exceeded entry limit (${maxSizeOfFilesInMB}MB). Please condense receipt files OR submit
        current request and upload remaining files in a new request.`"
            [dismissable]="false"
        />
    }

    <mds-button
        [id]="'upload-btn'"
        for="fileDropRef"
        [label]="uploadButtonTitle()"
        color="primary"
        [variant]="'tonal'"
        width="100%"
        (clickEvent)="upload()"
        class="rounded-sm"
    ></mds-button>
</div>

<input
    title="file-dropdown-ref"
    class="hidden"
    type="file"
    #fileDropRef
    [id]="idVal()"
    [accept]="acceptableTypes()"
    [multiple]="false"
    (change)="onFileSelected($event)"
/>
